const defaultRules = {
  title: '优惠头条全新上线！',
  content: [
    '聚合全网旅行优惠信息，机票签证酒店通通有！',
    '只要每天来看30秒，天天都有好礼送给你！',
    '活动须知：',
    '1.若打卡中断1天或以上，就会重新回到第一天，再次开始7天打卡任务哦~',
    '2.在法律允许范围内，租租车将对本次活动保留最终解释权，如有任何疑问，请联系客服咨询。'
  ]
};

const zzbRules = {
  title: '规则说明',
  content: [
    '1. 连续打卡7天，可获得翻倍奖励，即1400个猪猪币',
    '2. 对连续领取的记录，在第8天开始时会清零，重新开始计算',
    '3. 中断打卡1天或以上，连续领取记录也会被清零',
    '4. 可使用猪猪币兑换权益/商品，详情以页面显示为准',
    '5. 参与打卡时使用同一登录账号、同一终端设备等合理显示为同一用户的情形，均视为同一位用户',
    '6. 如出现违规行为（包括但不限于作弊领取、虚假交易、恶意套现等），租租车有权采取终止违规交易、追回不当利益等措施，并依据租租车相关规则进行处罚',
    '7. 租租车保留最终解释权，如有任何问题，欢迎在线或电话咨询租租车客服'
  ]
};

export {
  defaultRules,
  zzbRules
};
